import * as React from 'react';
import { BankButton, HorizontalLine, SingleBank } from './styled';
import Interbank from '../../../../assets/icons/payments/Interbank.svg';
import BCP from '../../../../assets/icons/payments/BCP.svg';
import Scotiabank from '../../../../assets/icons/payments/Scotiabank.svg';
import BBVA from '../../../../assets/icons/payments/BBVA.svg';
import GoToBank from '../../../../assets/icons/payments/goToBank.svg';

interface BankBlockProps {
  name: string;
  discount: string;
  description: string;
  url: string;
  buttonName: string;
  agentCode: string;
  list?: boolean;
}

const BankBlock = ({
  name,
  discount,
  description,
  url,
  buttonName,
  agentCode,
  list
}: BankBlockProps) => {
  const bankInfo = (item: string) => {
    switch (item) {
      case 'Interbank':
        return {
          img: Interbank,
          agentDescription: 'Este es el código de pago, por si te lo piden: '
        };
      case 'BBVA':
        return {
          img: BBVA,
          agentDescription: 'Este es el RUC UTP por si te lo piden: '
        };
      case 'Scotiabank':
        return {
          img: Scotiabank,
          agentDescription: 'Este es el RUC UTP por si te lo piden: '
        };
      case 'BCP':
        return {
          img: BCP,
          agentDescription: 'Este es el código de pago, por si te lo piden: '
        };
      default:
        return { img: '', agentDescription: '' };
    }
  };

  return (
    <SingleBank style={{ width: '100%' }}>
      <div>
        <img src={bankInfo(name).img} alt={name} />
        <span>{name}</span>
        <span style={{ color: '#84b1cc', fontWeight: '400' }}>|</span>
        {discount}% de descuento
      </div>
      <HorizontalLine />
      {list ? (
        <ul>
          <li>
            {bankInfo(name).agentDescription}
            <b>{agentCode}</b>
          </li>
          {name === 'Interbank' && <li>Solo se aceptan pagos por agentes</li>}
        </ul>
      ) : (
        <p>{description}</p>
      )}
      <BankButton
        onClick={() => {
          window.open(url, '_blank');
        }}
      >
        <span style={{ display: 'flex' }}>
          <img src={GoToBank} alt="Ir a banco" />
          {buttonName}
        </span>
      </BankButton>
    </SingleBank>
  );
};

export { BankBlock };
